/*
  FluoFree — kostencalculator voor ff-besparing.

  Liquid rendert de sectie al mét een doorgerekende standaardsituatie, zodat er
  zonder JavaScript een kloppende, statische berekening staat. Dit bestand maakt
  die berekening interactief; het rekent bij de start meteen opnieuw, zodat de
  bezoeker nooit een mengeling van twee opmaakstijlen ziet.

  Alle bedragen komen uit section settings — en bij voorkeur uit het Shopify
  product-object — en staan als data-attribuut op de sectie. Er staat hier
  bewust geen enkele prijs of capaciteit in code.

  De formule is dezelfde als in het prototype (lib/commerce.ts):
    jaarliters   = personen x liter per dag x 365
    filters      = naar boven afgerond, minimaal 1, op de filtercapaciteit
    lopend/jaar  = filters x filterprijs + eigen budget water en stroom
    kosten jaar1 = toestelprijs + filters x filterprijs + budget
    besparing    = flessenwater jaar 1 - kosten jaar 1   (fase-ab: alleen jaar 1)
    vanaf jaar 2 = flessenwater - filters x filterprijs - budget
                   (de toestelprijs valt dan weg)
    Geen terugverdientijd meer: die liep over meerdere jaren.

  Sinds de nieuwe indeling stuurt één schuif de liters per persoon per dag; de
  drie overige velden staan achter een dichtgeklapte <details> maar doen
  onveranderd mee zodra ze veranderen.
*/
(function () {
  'use strict';

  function getal(el, standaard) {
    var v = el ? parseFloat(el.value) : NaN;
    return isNaN(v) ? standaard : v;
  }

  /* start() draait ook bij elke shopify:section:load. Zonder markering kreeg
     elk invoerveld er dan een listener bij; dat rekende alleen vaker hetzelfde
     uit, maar het is dezelfde fout als in ff-koop.js en wordt hier op dezelfde
     manier voorkomen. Een door de editor opnieuw opgebouwde sectie levert verse
     nodes zonder markering en wordt dus alsnog netjes gebonden. */
  function gebonden(el) {
    if (el.getAttribute('data-ff-besparing-gebonden')) return true;
    el.setAttribute('data-ff-besparing-gebonden', '1');
    return false;
  }

  function start(root) {
    if (gebonden(root)) return;

    var cfg = {
      filterprijs: parseFloat(root.getAttribute('data-filterprijs')) || 0,
      capaciteit: parseFloat(root.getAttribute('data-capaciteit')) || 1,
      toestelprijs: parseFloat(root.getAttribute('data-toestelprijs')) || 0,
      maxMaanden: parseFloat(root.getAttribute('data-max-maanden')) || 36,
      locale: root.getAttribute('data-locale') || 'nl-NL',
      valuta: root.getAttribute('data-valuta') || 'EUR',
      geldformaat: root.getAttribute('data-geldformaat') || '€{{amount_with_comma_separator}}'
    };

    var invoer = {};
    ['personen', 'liters', 'flesprijs', 'budget'].forEach(function (naam) {
      invoer[naam] = root.querySelector('[data-ff-in="' + naam + '"]');
    });
    if (!invoer.liters) return;

    function uit(naam) { return root.querySelector('[data-ff-uit="' + naam + '"]'); }
    function balk(naam) { return root.querySelector('[data-ff-bar="' + naam + '"]'); }

    /* Bedragen worden met het money_format van de winkel opgemaakt, hetzelfde
       formaat dat de money-filter van Liquid gebruikt. Eerder stond hier Intl,
       en dat gaf een spatie achter het euroteken die de statische weergave niet
       heeft. Liquid is leidend, dus die kant is aangepast. */
    function groepeer(getal, decimaalteken, duizendteken) {
      var vast = Math.abs(getal).toFixed(2).split('.');
      var geheel = vast[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizendteken);
      return { geheel: geheel, decimalen: vast[1], negatief: getal < 0 };
    }

    function bedrag(waarde, zonderNullen) {
      return cfg.geldformaat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, sleutel) {
        var komma = sleutel.indexOf('comma_separator') !== -1;
        var d = komma ? ',' : '.';
        var t = komma ? '.' : ',';
        var g = groepeer(waarde, d, t);
        var geenDecimalen = sleutel.indexOf('no_decimals') !== -1
          || (zonderNullen && g.decimalen === '00');
        var uitkomst = g.geheel + (geenDecimalen ? '' : d + g.decimalen);
        return (g.negatief ? '-' : '') + uitkomst;
      });
    }

    function tekst(naam, waarde) {
      var el = uit(naam);
      if (el) el.textContent = waarde;
    }

    function breedte(naam, pct) {
      var b = balk(naam);
      if (b) b.style.width = Math.max(0, Math.min(100, pct)) + '%';
    }

    /* Liquid schrijft de literwaarde met een komma; hier hetzelfde doen, anders
       springt het grote getal bij de eerste aanraking van een punt naar een
       komma of andersom. */
    function komma(n) {
      return String(n).replace('.', ',');
    }

    function bereken() {
      var personen = getal(invoer.personen, 1);
      var liters = getal(invoer.liters, 1);
      var flesprijs = Math.max(0, getal(invoer.flesprijs, 0));
      var budget = Math.max(0, getal(invoer.budget, 0));

      var jaarliters = personen * liters * 365;
      var filters = Math.max(1, Math.ceil(jaarliters / cfg.capaciteit));
      var lopend = filters * cfg.filterprijs + budget;
      var flessen = jaarliters * flesprijs;
      var kostenJaar1 = cfg.toestelprijs + filters * cfg.filterprijs + budget;
      var besparing = flessen - kostenJaar1;
      var vanafJaar2 = flessen - filters * cfg.filterprijs - budget;
      var toontBesparing = besparing > 0;

      tekst('liters-waarde', komma(liters));
      tekst('personen-waarde', String(personen));

      var samen = root.getAttribute('data-label-samen') || '';
      var samenEl = uit('samen');
      if (samenEl && samen) {
        samenEl.textContent = samen
          .replace('%personen%', String(personen))
          .replace('%totaal%', komma(Math.round(personen * liters * 10) / 10));
      }

      tekst('flessen', bedrag(flessen, false));
      tekst('osmora', bedrag(lopend, false));
      /* Bij een positieve uitkomst staat hier de besparing, anders de kosten van
         jaar 1 zelf - niet het tekort, want dat is geen bedrag dat je betaalt. */
      tekst('besparing', bedrag(Math.round(toontBesparing ? besparing : kostenJaar1), true));
      tekst('jaar2', bedrag(Math.abs(Math.round(vanafJaar2)), true));

      /* De jaar-2-regel is alleen interessant als jaar 1 niets oplevert. */
      var rijJaar2 = root.querySelector('[data-ff-rij="jaar2"]');
      /* Levert ook jaar 2 niets op, dan geen "bespaar je" met een omgekeerd
         bedrag: de regel blijft weg (fase-av). */
      if (rijJaar2) rijJaar2.hidden = toontBesparing || vanafJaar2 <= 0;

      /* Het label boven de besparing wisselt mee: bij een negatieve uitkomst
         staat er niet "besparing" maar de tegenovergestelde tekst. Liquid doet
         serverzijdig precies hetzelfde. */
      var besparingLabel = uit('besparing-label');
      if (besparingLabel) {
        besparingLabel.textContent = toontBesparing
          ? (root.getAttribute('data-label-besparing') || besparingLabel.textContent)
          : (root.getAttribute('data-label-kosten1') || besparingLabel.textContent);
      }

      var getoond = toontBesparing ? besparing : kostenJaar1;
      var grootste = Math.max(flessen, lopend, Math.abs(getoond), Math.abs(vanafJaar2), 1);
      breedte('flessen', flessen / grootste * 100);
      breedte('osmora', lopend / grootste * 100);
      breedte('besparing', Math.abs(getoond) / grootste * 100);
      breedte('jaar2', Math.abs(vanafJaar2) / grootste * 100);

      var voet = uit('voet');
      var sjabloon = root.getAttribute('data-voet');
      if (voet && sjabloon) {
        /* Kale getallen, want Liquid vult %liters% en %prijs% ook kaal in:
           1095, niet 1.095, en 99, niet € 99. */
        voet.textContent = sjabloon
          .replace('%liters%', String(Math.round(jaarliters)))
          .replace('%filters%', String(filters))
          .replace('%prijs%', String(cfg.filterprijs));
      }
    }

    Object.keys(invoer).forEach(function (naam) {
      var el = invoer[naam];
      if (!el) return;
      el.addEventListener('input', bereken);
      el.addEventListener('change', bereken);
    });

    bereken();
  }

  function alles() {
    Array.prototype.slice.call(document.querySelectorAll('[data-ff-besparing]')).forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alles);
  } else {
    alles();
  }
  document.addEventListener('shopify:section:load', alles);
})();
